export default __webpack_public_path__ + "static/media/1_Carta Abierta Legalisierung_Jetzt.891497d0.pdf";